/** Rounding never completes progress (style guide, student progress labels): an unfinished 199 of 200 reads 99%, not 100%. */
export function completionPercent(completed: number, total: number): number {
    if (!total) return 0;
    return completed >= total ? 100 : Math.min(99, Math.round(completed * 100 / total));
}
